import gql from 'graphql-tag';

const DELETE_MAPPING_RECORD = gql`
  mutation deleteMappingRecord($id: Int!) {
    deleteMappingRecord(where: { id: $id })
  }
`;

export default DELETE_MAPPING_RECORD;
